import { Combobox, TextInput, useCombobox, Stack } from "@mantine/core";
import { ReactComponent as SearchIcon } from "../../../assets/icons/search.svg";
import { ReactComponent as NewsIcon } from "../../../assets/icons/news.svg";
import { ReactComponent as KnowledgeIcon } from "../../../assets/icons/knowledge.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import React, { useState } from "react";
import SectionTitle from "../../../components/Elements/SectionTitle/SectionTitle";
import { useNavigate } from "react-router-dom";
import "./ControlPanelSearch.css";

const controlPanelData = [
  {
    id: 1,
    section: {
      id: 3,
      name: "Knowledge Base(s)",
      icon: KnowledgeIcon,
    },
    title: "Client Knowledge Base",
    content: "externalknowledgebase.url",
  },
  {
    id: 2,
    section: {
      id: 3,
      name: "Knowledge Base(s)",
      icon: KnowledgeIcon,
    },
    title: "Client Knowledge Base",
    content: "externalknowledgebase.url",
  },
  {
    id: 3,
    section: {
      id: 1,
      name: "Company News",
      icon: NewsIcon,
    },
    title: "Team Update",
    content: "We know what you're thinking",
  },
  {
    id: 4,
    section: {
      id: 1,
      name: "Company News",
      icon: NewsIcon,
    },
    title: "We're Hiring",
    content: "We know what you're thinking",
  },
];

const ControlPanelSearch: React.FC = () => {
  const combobox = useCombobox();
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const filteredOptions = controlPanelData.filter((item) =>
    item.content.toLowerCase().includes(searchValue.toLowerCase().trim())
  );

  const handleOption = (option: any) => {
    if (option.section.id === 1) {
      navigate("/news");
    } else if (option.section.id === 3) {
      window.open(option.content, "_blank");
    }
    setSearchValue("");
  };

  const options = filteredOptions.map((item) => {
    const Icon = item.section.icon;
    return (
      <Combobox.Option
        value={item.content}
        key={item.id}
        onClick={() => handleOption(item)}
      >
        <Stack className="border-b border-[#2f2f31] px-2 py-4">
          <div className="text-[#9e9e9f] gap-1 flex font-bold uppercase items-center">
            <Icon className="inline" />
            <span>{item.section.name}</span>
          </div>
          <div>
            <span className="text-[#9e9e9f] text-base font-medium">
              {item.title}{" "}
            </span>
            <span className="text-neutral-50 text-base font-medium">
              --{">"} {item.content}
            </span>
          </div>
        </Stack>
      </Combobox.Option>
    );
  });

  return (
    <Stack className="w-full" gap="0.5rem">
      <SectionTitle Icon={SearchIcon} title="Search" />
      <Combobox
        onOptionSubmit={(optionValue) => {
          setSearchValue(optionValue);
          combobox.closeDropdown();
        }}
        store={combobox}
      >
        <Combobox.Target>
          <TextInput
            placeholder="Search your Control panel"
            value={searchValue}
            onChange={(event) => {
              setSearchValue(event.currentTarget.value);
              combobox.openDropdown();
              combobox.updateSelectedOptionIndex();
            }}
            onClick={() => combobox.openDropdown()}
            onFocus={() => combobox.openDropdown()}
            onBlur={() => combobox.closeDropdown()}
            classNames={{
              input: "search-input p-4 rounded-xl border border-neutral-50/20",
            }}
            rightSection={
              searchValue.length ? (
                <CloseIcon
                  fill="#fafafa"
                  className="mr-4 cursor-pointer"
                  onClick={() => setSearchValue("")}
                />
              ) : (
                <SearchIcon fill="#fafafa" className="mr-4" />
              )
            }
          />
        </Combobox.Target>

        <Combobox.Dropdown className="!bg-[#131316] !rounded-xl !mt-[-0.25rem]">
          {searchValue && (
            <div className="text-neutral-50 text-base font-medium px-4 py-2">
              Search results for "{searchValue}"
            </div>
          )}
          <Combobox.Options mah={400} style={{ overflowY: "auto" }}>
            {options.length === 0 ? (
              <Combobox.Empty>Nothing found</Combobox.Empty>
            ) : (
              options
            )}
          </Combobox.Options>
        </Combobox.Dropdown>
      </Combobox>
    </Stack>
  );
};

export default ControlPanelSearch;
